import React from 'react'
// context
import LinkedItemsAPI from 'containers/LinkedItems/layers/API/index'
import LinkedItemsActions from 'containers/LinkedItems/layers/Business/LinkedItemsActions'
// components
import LinkedItem from 'components/Modals/PlanItems/components/PlanLinks/components/LinkedItem/index'

export const LinkedItemContainer = props => (
  <LinkedItemsAPI>
    <LinkedItemsActions>
      <LinkedItem {...props} />
    </LinkedItemsActions>
  </LinkedItemsAPI>
)
